import _ from "lodash";

/**
 *  This function can take either an object or a class instance,
 *  and wraps any functions in a call to `dispatch`.  Due to the
 *  nature of things passed into this (actual ES6 classes, ES5 "classes",
 *  and objects), this needs to pry into a number of things to get the full
 *  list of potential methods.
 *
 *  Class methods, i.e. `myFunction() { ... }` do not show up in `Object.keys`
 *  or `Object.getOwnPropertyNames`, they only exist on the prototype. Instance
 *  methods will show up on `Object.keys` but not on the former.  We can grab
 *  both of these and join them together to get a list of all methods.
 *
 * */
export default function bindActionCreators<T extends object>(
  dispatch: any,
  executor: T,
): T {
  let properties = new Set(
    Object.getOwnPropertyNames(Object.getPrototypeOf(executor)).filter(
      (name) => name !== "constructor",
    ),
  );
  for (const property of Object.keys(executor as object)) {
    properties = properties.add(property);
  }
  const actions: any = {};
  for (const key of properties) {
    actions[key] = (...args: any[]) => {
      return dispatch(
        (executor[key as keyof typeof executor] as Function).apply(
          executor,
          args,
        ),
      );
    };
  }
  return actions as T;
}
